// extracted by mini-css-extract-plugin
export var container = "_oe-0";
export var dotAnimation = "_oe-2";
export var dotsLoading = "_oe-1";